import React from "react";
export type SubNavMode = "light" | "dark";
type ContextProps = {
  subNavMode: SubNavMode;
};
const Context = React.createContext<ContextProps | undefined>(undefined);
type ProviderProps = {
  children: React.ReactNode;
  mode: SubNavMode;
};
export const SubNavLayoutProvider = (props: ProviderProps) => {
  const {
    mode,
    children
  } = props;
  const value = {
    subNavMode: mode
  };
  return <Context.Provider value={value}>{children}</Context.Provider>;
};
export const useSubNavLayout = (): ContextProps => {
  const context = React.useContext(Context);
  if (context === undefined) {
    throw new Error("useSubNavLayout must be used within a SubNavLayoutProvider");
  }
  return context;
};